import Header from "@/sections/Header";
import Hero from "@/sections/Hero";
import HeroCoin from "@/sections/HeroCoin";
import CreateCTA from "@/sections/CreateCTA";
import LiveMarket from "@/sections/LiveMarket";
import HotRail from "@/sections/HotRail";
import StreakNudge from "@/components/StreakNudge";
import ResumeDraft from "@/components/ResumeDraft";
import VerifiedSpotlight from "@/sections/VerifiedSpotlight";
import Launchpad from "@/sections/Launchpad";
import Tokenomics from "@/sections/Tokenomics";
import MockTrading from "@/sections/MockTrading";
import WalletConnect from "@/sections/WalletConnect";
import Roadmap from "@/sections/Roadmap";
import Compliance from "@/sections/Compliance";
import FAQ from "@/sections/FAQ";
import Footer from "@/sections/Footer";

export default function Home() {
  return (
    <main className="min-h-screen bg-[#050505] text-white" data-testid="home-page">
      <Header />
      <div className="pt-16">
        <VerifiedSpotlight className="max-w-[1400px] mx-auto px-6 md:px-10 pt-6" />
        <ResumeDraft className="max-w-[1400px] mx-auto px-6 md:px-10 pt-6" />
        <StreakNudge />
      </div>
      <Hero />
      <HeroCoin />
      <CreateCTA />
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-14">
        <HotRail />
      </div>
      <LiveMarket />
      <Launchpad />
      <Tokenomics />
      <MockTrading />
      <WalletConnect />
      <Roadmap />
      <Compliance />
      <FAQ />
      <Footer />
    </main>
  );
}
